import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Matoum_International_Airport.webp';

const Project_one = () => {

  return (
   <>
   
         <div className='project_1_work' id="workBanner">
   
           <div className="container project_our_work">
   
             <div className="heading">
               <h1>Al Maktoum International Airport</h1>
             </div>
   
             <hr></hr>
             <div className='project_section'>
               <div className="project_section_content">
                 <h1 className="project_scope">Scope of Work</h1>
                 <p>The future hub of Dubai's aviation ambitions — planned to become the world's largest airport with a capacity of 260 million
                    passengers per annum. GEMCO contributed MEP infrastructure works to this landmark mega-project developed by Dubai
                    Aviation Engineering Projects (DAEP).</p>
                 <p>MAIN CONTRACTOR : -</p>
                 <p>MEP CONTRACTOR : Transgulf</p>
                 <p>GEMCO SCOPE OF WORKS : CHW works</p>
                 {/* <h2 className="project_years">2014 – 2022</h2> */}
               </div>
               <div className='project_1_card'>
                 <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
               </div>
             </div>
           </div>
         </div>
   
       </>

  )
}

export default Project_one